module.exports = __webpack_public_path__ + "img/deep-game.fb36617.png";